import React from 'react';

import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const MessageIcon = ({ width = 24, height = 24, color: colorProp, hovered }: IconProps) => {
  const { defaultColor } = useDefaultIconsColor();
  const color = colorProp || defaultColor;

  return (
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      {hovered && (
        <path
          d='M19.9269 10.932C20.1655 12.783 19.7656 14.5245 18.9207 15.9821L19.8043 19.2844C19.8946 19.6004 19.5979 19.8907 19.2819 19.8068L15.9925 18.9232C15.9925 18.9232 14.6323 19.6066 13.7444 19.8068C12.8566 20.007 11.9123 20.0582 10.9359 19.9294C7.28536 19.4456 4.38943 16.4465 4.04114 12.7766C3.57031 7.74577 7.74975 3.55988 12.7806 4.03717C16.444 4.379 19.4496 7.28139 19.9269 10.932Z'
          fill='#E6F7FF'
        />
      )}
      <path
        d='M15.9925 18.9232L19.2819 19.8068C19.5979 19.8907 19.8946 19.6004 19.8043 19.2844L18.9207 15.9821C19.7656 14.5245 20.1655 12.783 19.9269 10.932C19.4496 7.28139 16.444 4.379 12.7806 4.03717C7.74975 3.55988 3.57031 7.74577 4.04114 12.7766C4.38943 16.4465 7.28536 19.4456 10.9359 19.9294C11.9123 20.0582 12.8566 20.007 13.7444 19.8068'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.8812 11.0928C14.3823 11.0928 13.9741 11.501 13.9741 12C13.9741 12.4989 14.3823 12.9071 14.8812 12.9071C15.3801 12.9071 15.7883 12.4989 15.7883 12C15.7883 11.501 15.3801 11.0928 14.8812 11.0928Z'
        fill={color}
      />
      <path
        d='M9.11902 11.0928C8.62011 11.0928 8.21191 11.501 8.21191 12C8.21191 12.4989 8.62011 12.9071 9.11902 12.9071C9.61793 12.9071 10.0261 12.4989 10.0261 12C10.0261 11.501 9.61793 11.0928 9.11902 11.0928Z'
        fill={color}
      />
      <path
        d='M12.0004 11.0928C11.5015 11.0928 11.0933 11.501 11.0933 12C11.0933 12.4989 11.5015 12.9071 12.0004 12.9071C12.4993 12.9071 12.9075 12.4989 12.9075 12C12.9075 11.501 12.4993 11.0928 12.0004 11.0928Z'
        fill={color}
      />
    </svg>
  );
};
